import React from 'react';
import { useNode, Element } from '@craftjs/core';
import { useTheme } from '../../../contexts/ThemeContext';

export const ColumnsBlock = ({ columns, gap }) => {
  const { isDark } = useTheme();
  const { connectors: { connect, drag }, selected } = useNode((state) => ({
    selected: state.events.selected
  }));

  const gridCols = {
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4'
  };

  return (
    <div
      ref={(ref) => ref && connect(drag(ref))}
      className={`p-4 rounded-lg transition-all ${
        selected ? 'ring-2 ring-[#A2FF00]' : ''
      } ${isDark ? 'hover:bg-zinc-800/50' : 'hover:bg-gray-100'}`}
    >
      <div 
        className={`grid ${gridCols[columns] || 'grid-cols-2'}`}
        style={{ gap: `${gap || 16}px` }}
      >
        {Array.from({ length: columns || 2 }).map((_, index) => (
          <Element
            key={index}
            id={`column-${index}`}
            is={Column}
            canvas
          />
        ))}
      </div>
    </div>
  );
};

// Column component that accepts children
const Column = ({ children }) => {
  const { isDark } = useTheme();
  const { connectors: { connect } } = useNode();

  return (
    <div
      ref={connect}
      className={`min-h-[100px] p-3 rounded-lg border-2 border-dashed ${
        isDark ? 'border-zinc-700 bg-zinc-800/30' : 'border-gray-300 bg-gray-50'
      }`}
    >
      {children || (
        <p className={`text-sm text-center ${isDark ? 'text-zinc-500' : 'text-gray-400'}`}>
          Drop blocks here
        </p>
      )}
    </div>
  );
};

Column.craft = {
  displayName: 'Column',
  rules: {
    canMoveIn: () => true
  }
};

ColumnsBlock.craft = {
  displayName: 'Columns',
  props: {
    columns: 2,
    gap: 16
  },
  related: {
    toolbar: ColumnsBlockSettings
  }
};

function ColumnsBlockSettings() {
  const { actions: { setProp }, props } = useNode((node) => ({
    props: node.data.props
  }));
  const { isDark } = useTheme();

  return (
    <div className="space-y-4">
      <div>
        <label className={`block text-sm font-medium mb-2 ${isDark ? 'text-zinc-300' : 'text-gray-700'}`}>
          Number of Columns
        </label>
        <div className="flex gap-2">
          {[2, 3, 4].map((num) => (
            <button
              key={num}
              onClick={() => setProp(props => props.columns = num)}
              className={`flex-1 px-3 py-2 rounded-lg border ${
                props.columns === num
                  ? 'bg-[#A2FF00] text-black border-[#A2FF00]'
                  : isDark ? 'bg-zinc-800 border-zinc-700 text-white' : 'bg-white border-gray-300'
              }`}
            >
              {num}
            </button>
          ))}
        </div>
      </div>
      <div>
        <label className={`block text-sm font-medium mb-1 ${isDark ? 'text-zinc-300' : 'text-gray-700'}`}>
          Gap: {props.gap}px
        </label>
        <input
          type="range"
          min="8"
          max="48"
          value={props.gap}
          onChange={(e) => setProp(props => props.gap = parseInt(e.target.value))}
          className="w-full"
        />
      </div>
    </div>
  );
}

export { ColumnsBlockSettings, Column };
